import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Liste des utilisateurs actifs")
], -1)
const _hoisted_3 = { class: "flex justify-between items-center my-1" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "flex justify-end ml-auto" }

import {onMounted, ref} from "vue";
import {UserBasicRepresentation} from "@/models/user/UserBasicRepresentation";
import {getUser, getUsers} from "@/_services/user/user";
import ChangeBlacklistStateModal from "@/components/modal/blacklisting/ChangeBlacklistStateModal.vue";
import UserBlackListModal from "@/components/modal/blacklisting/UserBlackListModal.vue";
import {getUserHistoriqueBlackList} from "@/_services/blackList/blacklist";
import {UserBlacklistHistorique} from "@/models/blacklisting/UserBlacklistHistorique";
import ProgressSpinner from "primevue/progressspinner";
import Button from "primevue/button";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'EnabledUsersList',
  setup(__props) {

const isLoading = ref<boolean>(true);
const isWaitingForBlacklist = ref<boolean>(false);
const users = Array<UserBasicRepresentation>();
const tableData = ref<Array<UserBasicRepresentation>>(users);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[id]",
    fieldValue: "asc",
};
const showEditDialog = ref(false);
const showCreateDialog = ref(false);
const editDialogData = ref<UserBlacklistHistorique>({} as UserBlacklistHistorique);
const createDialogData = ref('');

onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

const populateDatatable = async (
    itemsPerPage: number,
    page: number,
    criteria?:string,
    sort?: { fieldLabel: string; fieldValue: string; }
) => {
    const [isLoadingDt, totalRecordsDt, tableDataDt] = await getUsers(itemsPerPage, page, 'accepted', true, criteria, sort);
    isLoading.value = isLoadingDt;
    totalRecords.value = totalRecordsDt;
    tableData.value = tableDataDt;
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
};

const onFilterDt = () => {
    if (criteria.value != "") {
        populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        populateDatatable(rows.value, page.value);
    }
};

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
    }
};

const redirectBlackListModal = async(user: UserBasicRepresentation) => {
    isWaitingForBlacklist.value = true;
    // if user has already been blocked in the past he's save in ce_user_blacklist table
    if (user.userBlackList === null) {
        createDialogData.value = user.uuid;
        showCreateDialog.value = true;
    }
    if (user.userBlackList !== null) {
        const [isLoadingDt, userHistoriqueBlackList] = await getUserHistoriqueBlackList(user.userBlackList);
        editDialogData.value = userHistoriqueBlackList;
        showEditDialog.value = true;
    }

    isWaitingForBlacklist.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isWaitingForBlacklist.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(ProgressSpinner), {
            style: {"width":"50px","height":"50px"},
            "aria-label": "blacklist spinner",
            pt: {
                    spinner: { style: { width: '50px', height: '50px', animationDuration: '.5s' } },
                    circle: { style: { stroke: '#007bff', strokeWidth: 4, animation: '2s' } }
                }
          })
        ]))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createVNode(ChangeBlacklistStateModal, {
      "historique-blacklist": editDialogData.value,
      "allow-blacklist-only": true,
      visible: showEditDialog.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showEditDialog).value = $event))
    }, null, 8, ["historique-blacklist", "visible"]),
    _createVNode(UserBlackListModal, {
      "user-uuid": createDialogData.value,
      visible: showCreateDialog.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showCreateDialog).value = $event))
    }, null, 8, ["user-uuid", "visible"]),
    _createVNode(_component_DataTable, {
      lazy: "",
      paginator: "",
      removableSort: "",
      currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
      template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      value: tableData.value,
      rows: rows.value,
      totalRecords: totalRecords.value,
      rowsPerPageOptions: rowsPerPageOptions,
      currentPage: currentPage.value,
      rowHover: true,
      loading: isLoading.value,
      onSort: _cache[3] || (_cache[3] = ($event: any) => (onSort($event))),
      onPage: onPaginate
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              type: "text",
              class: "form-control w-64 pl-10 pr-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500",
              onKeyup: _withKeys(onFilterDt, ["enter"]),
              placeholder: "Rechercher...",
              modelValue: criteria.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria).value = $event)),
              onInput: onClearInputFilter
            }, null, 8, ["onKeyup", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode("Utilisateurs actifs :   "),
          _createElementVNode("b", null, _toDisplayString(totalRecords.value), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_Column, { headerStyle: "width: 3rem" }),
          _createVNode(_component_Column, {
            field: "firstname",
            header: "Nom"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.firstname), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "lastname",
            header: "Prénom"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.lastname), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "email",
            header: "Email"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.email), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Action" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Button), {
                size: "small",
                icon: "pi pi-ban",
                class: "p-button-danger",
                title: "Blacklister",
                onClick: ($event: any) => (redirectBlackListModal(slotProps.data))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
  ]))
}
}

})